<template>
  <Modal>
    <Modal.Title>Owners</Modal.Title>
    <Modal.Body>
      <EntityListBody
        subtitle="Owners of this registered work"
        :entities="entities"
        :loading="loading"
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" :size="isMobile ? 'lg' : 'md'" @click="close()">
        Close
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'

import { useDevice } from '@/shared/composables/useDevice'
import type { CopyrightFile } from '@/features/copyright/composables/useCopyrightFile'
import EntityListBody from './EntityListBody.vue'
import { useAllOwners } from './useAllEntities'

const props = defineProps<{
  file: CopyrightFile
}>()

const { close } = useModal()
const { isMobile } = useDevice()
const { entities, loading } = useAllOwners(props.file)
</script>
